import styled from "styled-components";
import {
	Avatar as AntAvatar,
	Input as AntInput,
	Button as AntButton,
	Form as AntForm,
} from "antd";
import { NoImageUser } from "@assets";

export const RootContainer = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	position: relative;
	margin: 0 16px;
	min-height: calc(100vh - 70px);
	overflow: hidden;
`;

export const AvatarWrapper = styled.div`
`;

export const Avatar = styled(AntAvatar)`
	border-radius: 12px !important;
`;

export const ProfileInputContainer = styled.div`
	position: absolute;
	bottom: -15px;
	left: 0px;
	width: 62px;
	height: 32px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 0px 0px 12px 12px;
`;

export const InputLabel = styled.p`
	position: absolute;
	left: 24px;
	top: -8px;
	z-index: 30;
	margin: 0px;
	padding: 0px 4px;

	color: #535b5d;
	background-color: white;
	font-size: 12px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
`;

export const FileInput = styled.input`
	display: none;
`;

export const SaveButton = styled(AntButton)`
	box-sizing: border-box !important ;
	width: 100%;
	height: 52px;
	margin: 0px 16px 10px;

`;

export const NoImageIcon = styled.img.attrs({
	src: `${NoImageUser}`,
	alt: "no_img",
})`
	margin-top: 4px;
	width: 62px;
	height: 62px;
	border-radius: 12px;
`;

export const PhoneNumber = styled.p`
  margin-top: 16px;
  color: #6D7F8A;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 175% */
`

export const Form = styled(AntForm)`
	width: 100%;
	height: 100%;
  margin-top: 14px;
	position: relative !important;

	.ant-form-item {
		margin: 0 0 24px 0px;
	}

	.ant-form-item-label {
		padding-bottom: 0 !important;
    text-align: left;
	}

	.ant-form-item-label label {
		margin: 0px 0 0 16px;
		color: #004F9C;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
		padding-bottom: 0px !important;
	}

	.ant-form-item-explain {
		text-align: left; /* align warning text to the left */
		margin-left: 24px;
	}
`;

export const Input = styled(AntInput)`
	border-radius: 16px !important;
	height: 48px;
  background: #D9D9D9;
  padding-left: 16px;
	/* background-color: ${(props) =>
		props.inputType === "phone" ? "#FFF !important" : "#FFF"};
	color: ${(props) =>
		props.inputType === "phone" ? "#0095DA !important" : "#000000"}; */

  color: #000;
	font-size: 16px !important ;
	font-weight: 500;
	line-height: 21px;
	text-align: left;

	.ant-input::placeholder {
		color: #686b6e;
		font-weight: 200;
		font-size: 18px;
	}
`;
